import type { HTMLAttributes, ReactNode } from 'react'

export function EsCard({
  emphasis = false,
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & {
  emphasis?: boolean
  children: ReactNode
}) {
  const skin = emphasis
    ? 'bg-es-navy text-es-onNavy'
    : 'bg-es-white text-es-body'

  return (
    <div
      className={`rounded-[var(--radius-lg)] p-5 md:p-6 shadow-[var(--shadow-card)] border ${
        emphasis ? 'border-es-navy' : 'border-es-soft'
      } ${skin} ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}
